import { Circle } from '../../../services/microsoft/msGraphApi';
import { createReduxAction, ReduxAction } from '../../utils';
import { NextcloudActionType } from './actionTypes';
import { Share } from 'nextcloud-api';

export type SetCircles = ReduxAction<
    NextcloudActionType.SetCircles,
    { circles: Circle[] }
>;

export const setCircles = (circles: Circle[]): SetCircles =>
    createReduxAction(NextcloudActionType.SetCircles, { circles });

export type SetShares = ReduxAction<
    NextcloudActionType.SetShares,
    { shares: Share[] }
>;

export const setShares = (shares: Share[]): SetShares =>
    createReduxAction(NextcloudActionType.SetShares, { shares });
